import { ICardInfoData } from "../interfaces/card-info.interface";

export const CARD_ICON_DIR = 'images/shared/cards';
export const NUMBER_ICON_DIR = 'images/shared/steps';

export const AIDevelopmentCardInfo: ICardInfoData[] = [{
    icon: `${CARD_ICON_DIR}/rocket.png`,
    title: "expertise",
    text: "Our team consists of experienced AI and software development professionals who excel in their respective fields."
},
{
    icon: `${CARD_ICON_DIR}/bulb.png`,
    title: "custom solutions",
    text: "We understand that one size doesn't fit all. We tailor AI solutions to your specific business needs."
},
{
    icon: `${CARD_ICON_DIR}/shield.png`,
    title: "security",
    text: "We prioritize data security and implement the highest industry standards to protect your information."
},
{
    icon: `${CARD_ICON_DIR}/rocket.png`,
    title: "support",
    text: "Our commitment to your success doesn't end with project delivery. We offer ongoing support and maintenance to ensure your software continues to perform optimally."
}, {
    icon: `${CARD_ICON_DIR}/cheese.png`,
    title: "proven track record",
    text: "We have a history of delivering successful AI-driven projects for a wide range of industries."
}]

export const AIDevelopmentNumberedCardInfo: ICardInfoData[] = [{
    icon: `${NUMBER_ICON_DIR}/01.png`,
    title: "custom ai-powered solutions",
    text: "We create custom AI solutions—like predictive analytics, NLP, and computer vision—tailored to your unique business needs."
},
{
    icon: `${NUMBER_ICON_DIR}/02.png`,
    title: "enhanced data insights",
    text: "Our AI software unlocks your data's potential, delivering insights to help you make smart, timely business decisions."
},
{
    icon: `${NUMBER_ICON_DIR}/03.png`,
    title: "automation for efficiency",
    text: "AI automates tasks to cut errors and free your team for strategic work—like chatbots, data entry, and process automation."
},
{
    icon: `${NUMBER_ICON_DIR}/04.png`,
    title: "personalized customer experience",
    text: "Boost customer satisfaction and conversions with AI-powered personalized recommendations based on user behavior."
}, {
    icon: `${NUMBER_ICON_DIR}/05.png`,
    title: "competitive advantage",
    text: "Adopt AI early to outpace competitors, spot opportunities, and lead in innovation and efficiency."
},
{
    icon: `${NUMBER_ICON_DIR}/06.png`,
    title: "predictive maintenance",
    text: "AI predicts equipment failures and triggers maintenance to prevent costly downtime."
},
{
    icon: `${NUMBER_ICON_DIR}/07.png`,
    title: "scalability and flexibility",
    text: "Our AI solutions scale with your business, adapting to growth and protecting your investment."
},
{
    icon: `${NUMBER_ICON_DIR}/08.png`,
    title: "security and compliance",
    text: "We ensure your AI software is secure, compliant, and meets industry data protection standards."
}]